<template>
  <Card tag="form" variant="widget" class="residential-template-mutate-presentation" @submit.prevent="$emit('submit')">
    <template #header>
      <div class="card-v2__title">{{ $t('presentation') }}</div>
      <FieldBuilder
        :value="value.themeLayout"
        @input="e => $emit('updateValue', { key: 'themeLayout', value: e, slot: true })"
        :item="data"
        :customFieldSchemas="customFieldSchemas"
        :placement="placement"
        :build="false"
        add-missing
        ignore-theme
      />
    </template>
    <template #default>
      <div class="residential-template-mutate-presentation__input">
        <CustomFields
          data-field="fields"
          :value="value"
          @input="e => $emit('updateValue', e)"
          :schema="customFieldSchemas"
          :data="data"
          :validator="validator"
          :placement="placement"
        >
          <!-- render slots -->
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" @input="e => $emit('updateValue', { ...e, slot: true })" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card-v2'
import { i18n } from '@/i18n'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Residential/StepsFields/FieldRenderer.vue'
import FieldBuilder from '@/components/FieldBuilder'

const meta = {
  order: 2,
  id: 'presentation',
  label: i18n.tc('presentation'),
  icon: ['fal', 'image'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    data: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      placement: ['residential-template:presentation'],
    }
  },
  components: {
    Card,
    CustomFields,
    FieldRenderer,
    FieldBuilder,
  },
}
</script>

<style lang="scss">
.residential-template-mutate-presentation {
  $cols: 6;

  & > .card-v2 {
    &__header {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
  & > .card__content {
    padding: 0;
  }

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;
  }

  [data-field='fields'] {
    grid-column-end: span $cols;
  }
}
</style>
